export enum TokenExpired {
  TOKEN_EXPIRED_STATUS_CODE = '401',
  FORBIDDEN_USER_CODE = '403',
  FORBIDDEN_USER = 'error 403',
  TOKEN_EXPIRED_STATUS_MESSAGE = 'Code: 401'
}
